import React from "react";
import "./cricket.m.css";
import { sortBy } from "lodash";

function Live({ liveData }) {
  const rows = liveData;
  if (!rows.length) return null;
  const data = rows[0];
  const pArr = data.participants;
  const teams = pArr[0] && !("firstup" in pArr[0]) ? [...pArr].reverse() : pArr;
  let target = teams[0].value;
  if (teams[1].value) {
    target = (target || "").split("/")[0];
  }
  const url = "/sport/cricket/ilt20-match-center";
  return (
    <div styleName="live">
      <div styleName="title">
        <div styleName="icon">
          <img src="https://images.assettype.com/gulfnews-uat/2025-11-27/olitz4s6/dp-world.png" />
        </div>
        {/* <div styleName="name"></div> */}
        <div styleName="is-live">
          <div styleName="live-dot-tag">
            <span styleName="dot"></span>
            <span styleName="tag">LIVE</span>
          </div>
        </div>
      </div>
      <a href={url + "?id=" + data.match_id}>
        <div styleName="live-item">
          {teams[0].short_name}&nbsp;
          <p>{target}</p>vs&nbsp;{teams[1].short_name}&nbsp;
          <p>{teams[1].value}</p>
        </div>
      </a>
    </div>
  );
}
export default Live;
